/**
 * Themes available in the applicaiton
 */
export enum Theme {
    Shopliftr = "SHOPLIFTR",
    Vericast = "VERICAST"
}
